// Copyright (c) 2016 Deere & Company

import View from './view';
import t from 'tcomb';

const Views = t.list(View, 'Views');

export const getDefaultState = () =>
    new Views([
        {
            columns: [
                {
                    key: 'pin',
                    value: 'PIN'
                },
                {
                    key: 'contractNumber',
                    value: 'Contract Number'
                },
                {
                    key: 'responsibleDealer',
                    value: 'Responsible Dealer'

                },
                {
                    key: 'dealerName',
                    value: 'Dealer Name'
                },
                {
                    key: 'dealerCity',
                    value: 'Dealer City'
                },
                {
                    key: 'customerNumber',
                    value: 'Customer Number'
                },
                {
                    key: 'customerName',
                    value: 'Customer Name'
                },
                {
                    key: 'planName',
                    value: 'Plan Name'
                },
                {
                    key: 'planDescription',
                    value: 'Plan Description'
                },
                {
                    key: 'serviceIntervalNumber',
                    value: 'Service Interval Number'
                },
                {
                    key: 'serviceIntervalType',
                    value: 'Service Interval Type'
                },
                {
                    key: 'intervalTypeDescription',
                    value: 'Interval Type Description'
                },
                {
                    key: 'intervalBeginDate',
                    value: 'Interval Begin Date'
                },
                {
                    key: 'intervalEndDate',
                    value: 'Interval End Date'
                },
                {
                    key: 'completionDate',
                    value: 'Completion Date'
                },
                {
                    key: 'hoursLimit',
                    value: 'Hours Limit'
                },
                {
                    key: 'actualHours',
                    value: 'Actual Hours'
                },
                {
                    key: 'serviceIntervalStatus',
                    value: 'Service Interval Status'
                },
                {
                    key: 'statusDescription',
                    value: 'Status Description'
                },
                {
                    key: 'model',
                    value: 'Model'
                },
                {
                    key: 'planStartDate',
                    value: 'Plan Start Date'

                },
                {
                    key: 'planEndDate',
                    value: 'Plan End Date'
                }
            ],
            name: 'standard view',
            sortBy: [
                {
                    key: 'planEndDate',
                    order: 'DESC',
                    value: 'Plan End Date'
                }
            ]
        }
    ]);

export default Views;



// WEBPACK FOOTER //
// ./src/reports/maintenance-plan/state/views.js